import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "@/assets/style/main.scss";
import store from "@/store/index";
import authentication from "@/plugins/authentication";
import VueToast from "vue-toast-notification";
import elementLocale from "element-ui/lib/locale";
import elementLangEn from "element-ui/lib/locale/lang/en";

elementLocale.use(elementLangEn);

Vue.use(authentication);
Vue.use(VueToast, { position: "top-right", duration: 2000 });

Vue.config.productionTip = false;

Vue.$keycloak.init({ onLoad: "login-required" }).then(async (auth) => {
  if (!auth) {
    window.location.reload();
  } else {
    await store.dispatch("user/fetchProfile");

    new Vue({
      el: "#app",
      store,
      router,
      render: (h) => h(App),
    });
  }

  setInterval(() => {
    Vue.$keycloak.updateToken(70);
  }, 6000);
});
